const drinks = [
    {
        title: "Coca-Cola",
        image: require("../image/sweet/boisson-coca.png"),
        paragraphe: "Normal et zéro",
        price: "drinkPrice",
        top: "",
    },
    {
        title: "Cristaline",
        image: require("../image/sweet/boisson-cristaline.png"),
        paragraphe: "Eau",
        price: "waterPrice",
        top: "",
    },
    {
        title: "Oasis",
        image: require("../image/sweet/boisson-oasis.png"),
        paragraphe: "Tropical",
        price: "drinkPrice",
        top: "",
    },
];

export default drinks;
